import React, { useState } from "react";

import * as Styled from "./auth.styled";

type PasswordInputProps = {
  id: string;
  name: string;
  value: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  autoComplete: string;
};

export const PasswordInput = ({
  id,
  name,
  value,
  onChange,
  autoComplete,
}: PasswordInputProps) => {
  const [visible, setVisible] = useState(false);

  return (
    <Styled.InputWrap>
      <Styled.Input
        id={id}
        name={name}
        type={visible ? "text" : "password"}
        value={value}
        onChange={onChange}
        autoComplete={autoComplete}
      />
      <Styled.PasswordToggle
        type="button"
        onClick={() => setVisible((current) => !current)}
        aria-label={visible ? "Hide password" : "Show password"}
      >
        <i className={visible ? "pi pi-eye-slash" : "pi pi-eye"} aria-hidden />
      </Styled.PasswordToggle>
    </Styled.InputWrap>
  );
};
